import React from 'react'
import { DownloadTheWestQrCode } from './TWDownloadAppQR'
import {
    AppDownloadButtonsSection,
    StyledAppDownloadQrCodeContainer,
    StyledAppDownloadQrCodeText,
    StyledDownloadAppButton,
} from './TWAppDownloadWidget.styled'

type TWAppDownloadWidgetProps = {
    inverseButton?: boolean
}

export const TWAppDownloadWidget = ({
    inverseButton,
}: TWAppDownloadWidgetProps) => {
    return (
        <>
            <StyledAppDownloadQrCodeContainer>
                <DownloadTheWestQrCode />
                <StyledAppDownloadQrCodeText>
                    Scan to get the app
                </StyledAppDownloadQrCodeText>
            </StyledAppDownloadQrCodeContainer>
            <AppDownloadButtonsSection>
                <StyledDownloadAppButton
                    inverse={inverseButton}
                    href="https://thewe.st/app"
                >
                    Download the app
                </StyledDownloadAppButton>
            </AppDownloadButtonsSection>
        </>
    )
}
